import React from "react";
import SelectBox from "devextreme-react/select-box";
import { useMemo } from "react";
import { useCommonContext } from "../../contexts/common";
import { sf_hinhthucmiengiam } from "../../models/response/category/sf_hinhthucmiengiam";

type ComboBoxnhomMienGiamProps = {
    dataSource: sf_hinhthucmiengiam[],
    isReadonly?: boolean,
    value?: number,
    onValueChanged: (id: number) => void,
    className?: string,
    isShowClearButton?: boolean,
    preText?: string,
    stylingMode?: "outlined" | "filled" | "underlined",

}
const ComboBoxNhomMienGiam = (props: ComboBoxnhomMienGiamProps) => {
    const { translate } = useCommonContext();
    const store = useMemo(() => {
        //const uniqueMienGiam = props.dataSource.map(miengiam => miengiam.nhom_mien_giam);
        const uniqueMienGiam = Array.from(new Set(props.dataSource.map(miengiam => miengiam.nhom_mien_giam)));
        return uniqueMienGiam.map(items => ({
            id: items,
            name: 'Nhóm ' + items
        }));
    }, [props.dataSource])
    return (
        <SelectBox dataSource={store}
            displayExpr={"name"}
            valueExpr={"id"}
            value={props.value}
            stylingMode={props.stylingMode || "outlined"}
            readOnly={props.isReadonly === true}
            placeholder={translate("Nhóm")}
            width={120}
            height={34}
            dropDownOptions={{
                width: 'auto',
                minWidth: 200,
                maxWidth: 400,
            }}
            className={"default_selectbox " + (props.className ? props.className : "")}
            showClearButton={props.isShowClearButton === true}
            showSelectionControls={true}
            searchEnabled={true}
            onValueChanged={(e) => {
                props.onValueChanged(e.value)
            }} />
    );
}
export default ComboBoxNhomMienGiam;